const SUPPORT = 'https://support.inpart.io/hc/en-us';

export const EXTERNAL_URLS = {
    EVALUATE: 'https://discover.evaluate.com/inpart-partnership',
    PIPELINE_TAB: '7558',
    OMNIUM_TAB: '7411',
    SUPPORT,
    SUPPORT_MERGE: `${SUPPORT}/articles/7950269450140-Merge-Duplicate-Companies-and-Contacts`,
    SUPPORT_CONTACTS: `${SUPPORT}/articles/5444599510684-Create-and-manage-contacts`,
    IN_PART: 'https://www.inpart.io/products/connect/demo?plan=campaigns'
};
